import React, { useState } from 'react'
import AddProductsButton from '../../../buttons/AddProductsButton'
import SearchInput from '../../../inputs/SearchInput'

function SearchBox({ category, products, setProducts, products_types, searchResult }) {
  const [search_value, setSearchValue] = useState('')

  const inputHandler = async (e) => {
    setSearchValue(e.target.value)
    searchResult(e.target.value)
  }

  const submitSearch = async (e) => {
    e.preventDefault()
  }

  return (
    <div className={'py-4 sm:py-9 px-3 sm:px-8 w-full block'}>
      <div className="grid sm:grid-cols-2 gap-6">
        <form className="flex items-center justify-center" onSubmit={submitSearch}>
          <SearchInput
            search_value={search_value}
            inputHandler={inputHandler}
            placeholder={'نام محصول را وارد کنید'}
          />
        </form>

        <AddProductsButton
          category={category}
          products={products}
          setProducts={setProducts}
          products_types={products_types}
        />
      </div>
    </div>
  )
}

export default React.memo(SearchBox)
